import { AudioPlayer, Playlist } from "@iyk/vf-ui"

export const ExclusivePlaylistCard = ({ playlist, onOpenExclusive }: ExclusivePlaylistCard.Props) => {
  const { activePlaylistId, setActivePlaylist, clearActivePlaylist } = Playlist.usePlaylistInteraction()

  const isOpenDrawer = activePlaylistId === playlist.id

  const handleOpenDrawer = (open: boolean) => {
    if (open) {
      setActivePlaylist(playlist.id)
      onOpenExclusive()
    } else {
      clearActivePlaylist()
    }
  }

  return (
    <Playlist.AudioPlayerDrawer
      open={isOpenDrawer}
      onOpenChange={handleOpenDrawer}
      playlist={playlist}
      trigger={
        <div role="button">
          <PlaylistCard playlist={playlist} />
        </div>
      }
    />
  )
}

function PlaylistCard({ playlist }: { playlist: AudioPlayer.Playlist }) {
  const { trackIsPlaying, currentTrack, playPlaylist, togglePlayPause, lang } = Playlist.useAudioPlayer()

  const isCurrentTrackInPlaylist = currentTrack?.playlist.id === playlist.id
  const isCurrentPlaylistPlaying = isCurrentTrackInPlaylist && trackIsPlaying

  const handlePlayPauseClick = () => {
    if (isCurrentTrackInPlaylist) {
      togglePlayPause()
    } else {
      playPlaylist(playlist)
    }
  }

  return (
    <div className="flex h-36 overflow-hidden rounded bg-grayA-2 relative">
      <img
        src={playlist.coverImageUrl}
        alt={playlist.title}
        className="aspect-square object-cover shrink-0"
      />
      <div className="flex-1 flex flex-col justify-between px-3 py-2 text-left gap-4">
        <div className="flex flex-col items-start gap-2">
          <div>
            <p className="line-clamp-2 break-words">{playlist.title}</p>
            <p className="text-sm text-gray-11">{playlist.artist}</p>
          </div>
          {AudioPlayer.Playlist.$match(playlist, {
            Released: () => null,
            PartiallyReleased: (p) => <Playlist.ReleaseDateTag releaseDate={p.releaseDate} />,
            Unreleased: (p) => <Playlist.ReleaseDateTag releaseDate={p.releaseDate} />
          })}
        </div>

        <p className="text-sm text-gray-11">
          {playlist.tracks.length} {Playlist.Utils.pluralizeTrack(playlist.tracks.length, lang)}
        </p>
      </div>

      {!Playlist.Utils.isPlaylistUnreleased(playlist) && (
        <div className="absolute right-2 bottom-2">
          <Playlist.PlayPauseButton isPlaying={isCurrentPlaylistPlaying} onClick={handlePlayPauseClick} />
        </div>
      )}
    </div>
  )
}

namespace ExclusivePlaylistCard {
  export type Props = {
    playlist: AudioPlayer.Playlist
    onOpenExclusive: () => void
  }
}
